import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
// Models
import { VehicleLogbook, VehicleLogTableItem  } from '@mocca-technologies/model';

import { DroneLogbookTemplate } from '../../logbook-templates/drone-logbook-template/drone-logbook-template.component';
import { selectedValues } from '../../logbooks-menu/logbooks-menu.component';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-drone-table',
  templateUrl: './drone-table.component.html',
  styleUrls: ['./drone-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DroneTableComponent  implements OnInit {

  /**
   * Input Variables
   */

  @Input() rows: VehicleLogTableItem[];
  @Input() droneLogbook: VehicleLogbook;
  @Input() selectedValues: selectedValues;

  /**
   * Variables
   */

  columnsDroneLog = [];

  private destroy$ = new Subject<void>();

  logType = 'drone';

  constructor(private modalCtrl: ModalController,
              private translateService: TranslateService
  ) {}

  // #region --> Life Cycle Methods

  ngOnInit() {
    this.initColumns();

    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.initColumns();
      });
  }

  // #endregion --> Life Cycle Methods

  // #region --> Page Methods

  /**
   * Method to open the document visualizer with the drone logbook
   */

  async downloadDroneLogbook() {
    const modal = await this.modalCtrl.create({
      component: DroneLogbookTemplate,
      cssClass: 'templateModal',
      componentProps: {
        rows: this.rows,
        droneLogbook: this.droneLogbook,
        selectedDrone: this.selectedValues.selectedVehicle,
      },
    });
    modal.present();
  }

  private initColumns() {
    this.columnsDroneLog = [
      { field: 'flightOperationUuid', headerName: 'Flight Operation UUID', filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 180, hide: true },
      { field: 'date', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.DATE'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 120 },
      { field: 'location', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.LOCATION'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 260 },
      { field: 'takeoffTime', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.TAKEOFF_TIME'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'landingTime', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.LANDING_TIME'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 150 },
      { field: 'flightDuration', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.FLIGHT_DURATION'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 130 },
      { field: 'numFlights', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.NUMBER_OF_FLIGHTS'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 120 },
      { field: 'pilot', headerName: this.translateService.instant('PAGES.LOGBOOKS.VEHICLE_LOGBOOK.PILOT'), filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 170 },
      { field: 'notes', headerName: 'Notes', filter: true, autoHeaderHeight: true, wrapText: true, autoHeight: true, resizable: true, minWidth: 180, hide: true },
    ];
  }

  // #endregion --> Page Methods

  /**
   * Check if current screen is mobile view
   */
  isMobileView(): boolean {
    return window.innerWidth < 600;
  }

  isDesktopView(): boolean {
    return window.innerWidth >= 1024;
  }

}
